import Validator from '../../validator';

const ChangePolicyLimitValidator = new Validator([
  {
    field: 'effDate',
    method: 'isEmpty',
    validWhen: false,
    message: 'Effective Date is required.',
  },
  {
    field: 'description',
    method: 'isEmpty',
    validWhen: false,
    message: 'Description of this Request is required.',
  },
]);

export default ChangePolicyLimitValidator;
